import { IconListElement, Separator, Text } from "@nju/ui";
import { formatDate, parseMegabytesToGigabytes } from "@nju/utils";

interface ISidebarPackageGbOfferBenefitsProps {
  anniversaryDate: string;
  productOfferGrantValue: string;
  productOfferPrice: number;
}

export function SidebarPackageGbOfferBenefits({
  productOfferPrice,
  productOfferGrantValue,
  anniversaryDate,
}: ISidebarPackageGbOfferBenefitsProps) {
  const countryPackage = (
    <>
      <Text weight="bold">paczka GB w kraju</Text>
      <Separator size="none" tone="invisible" />
      <Text size="s">{productOfferPrice} GB w kraju</Text>
    </>
  );

  const roamingPackage = (
    <>
      <Text weight="bold">paczka GB w roamingu</Text>
      <Separator size="none" tone="invisible" />
      <Text size="s">
        {parseMegabytesToGigabytes(productOfferGrantValue)} GB w UE
      </Text>
    </>
  );

  const anniversaryDatePackage = (
    <>
      <Text weight="bold">ważność pakietu</Text>
      <Separator size="none" tone="invisible" />
      <Text size="s">
        pakiet GB będzie ważny do <br /> {formatDate(anniversaryDate)}
      </Text>
    </>
  );

  return (
    <>
      <IconListElement
        iconAlign="start"
        iconName="globe"
        iconSize="medium"
        mode="raw"
        text={countryPackage}
      />
      <IconListElement
        iconAlign="start"
        iconName="plane"
        iconSize="medium"
        mode="raw"
        text={roamingPackage}
      />
      <IconListElement
        iconAlign="start"
        iconName="history"
        iconSize="medium"
        mode="raw"
        text={anniversaryDatePackage}
      />
    </>
  );
}
